import React from "react";
import "./WhyBrick.css";
const WhyBrick = () => {
  return (
    <div className="why-brick-container">
      <h1>Why Civil Syndicate</h1>
      <p>
        We ensure peace of mind, trust, and transparent house construction
        services.
      </p>
      <div className="why-brick-all-card">
        <div className="why-brick-sinlge-all-card">
          <img
            src="https://d2e6x8l1x3qfpt.cloudfront.net/2023-04/RBL%20Bank%20Woman%27s%20First%20Debit%20Card_Keybenefits.png"
            alt=""
          />
          <h3>Safe Money Transaction</h3>
          <p>No Advance. Contractor is paid only once the work is complete</p>
        </div>

        <div className="why-brick-sinlge-all-card">
          <img
            src="https://d2e6x8l1x3qfpt.cloudfront.net/2023-04/RBL%20Bank%20Woman%27s%20First%20Debit%20Card_Keybenefits.png"
            alt=""
          />
          <h3>Absolute Transparency</h3>
          <p>Clear and Detailed Quatation Online tracking of project</p>
        </div>
        <div className="why-brick-sinlge-all-card">
          <img
            src="https://d2e6x8l1x3qfpt.cloudfront.net/2023-04/RBL%20Bank%20Woman%27s%20First%20Debit%20Card_Keybenefits.png"
            alt=""
          />
          <h3>Assured Quality Control</h3>
          <p>470+ Quality Checks performed by team of</p>
        </div>
        <div className="why-brick-sinlge-all-card">
          <img
            src="https://d2e6x8l1x3qfpt.cloudfront.net/2023-04/RBL%20Bank%20Woman%27s%20First%20Debit%20Card_Keybenefits.png"
            alt=""
          />
          <h3>Safe Money Transaction</h3>
          <p>No Advance. Contractor is paid only once the work is complete</p>
        </div>
      </div>
    </div>
  );
};

export default WhyBrick;
